/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistQualitativeQuestionOperationalScopeDTO} from './ChecklistQualitativeQuestionOperationalScopeDTO';

/**
 * The ChecklistQualitativeQuestionDTO model module.
 * @module model/ChecklistQualitativeQuestionDTO
 * @version v0
 */
export class ChecklistQualitativeQuestionDTO {
  /**
   * Constructs a new <code>ChecklistQualitativeQuestionDTO</code>.
   * @alias module:model/ChecklistQualitativeQuestionDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistQualitativeQuestionDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistQualitativeQuestionDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistQualitativeQuestionDTO} The populated <code>ChecklistQualitativeQuestionDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistQualitativeQuestionDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('checklistQualitativeQuestionOperationalScopes'))
        obj.checklistQualitativeQuestionOperationalScopes = ApiClient.convertToType(data['checklistQualitativeQuestionOperationalScopes'], [ChecklistQualitativeQuestionOperationalScopeDTO]);
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('question'))
        obj.question = ApiClient.convertToType(data['question'], 'String');
      if (data.hasOwnProperty('note'))
        obj.note = ApiClient.convertToType(data['note'], 'String');
      if (data.hasOwnProperty('supervisedEntity'))
        obj.supervisedEntity = ApiClient.convertToType(data['supervisedEntity'], 'Boolean');
      if (data.hasOwnProperty('notSupervisedEntity'))
        obj.notSupervisedEntity = ApiClient.convertToType(data['notSupervisedEntity'], 'Boolean');
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
      if (data.hasOwnProperty('displayId'))
        obj.displayId = ApiClient.convertToType(data['displayId'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistQualitativeQuestionDTO.prototype.id = undefined;

/**
 * @member {Array.<module:model/ChecklistQualitativeQuestionOperationalScopeDTO>} checklistQualitativeQuestionOperationalScopes
 */
ChecklistQualitativeQuestionDTO.prototype.checklistQualitativeQuestionOperationalScopes = undefined;

/**
 * @member {Number} position
 */
ChecklistQualitativeQuestionDTO.prototype.position = undefined;

/**
 * @member {String} question
 */
ChecklistQualitativeQuestionDTO.prototype.question = undefined;

/**
 * @member {String} note
 */
ChecklistQualitativeQuestionDTO.prototype.note = undefined;

/**
 * @member {Boolean} supervisedEntity
 */
ChecklistQualitativeQuestionDTO.prototype.supervisedEntity = undefined;

/**
 * @member {Boolean} notSupervisedEntity
 */
ChecklistQualitativeQuestionDTO.prototype.notSupervisedEntity = undefined;

/**
 * @member {String} tooltip
 */
ChecklistQualitativeQuestionDTO.prototype.tooltip = undefined;

/**
 * @member {Number} displayId
 */
ChecklistQualitativeQuestionDTO.prototype.displayId = undefined;

